import { render, staticRenderFns } from "./MYOBOAth.vue?vue&type=template&id=47b4a459&scoped=true&"
import script from "./MYOBOAth.vue?vue&type=script&lang=js&"
export * from "./MYOBOAth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b4a459",
  null
  
)

export default component.exports